<template>
  <div>
    <div class="formWrapper niche-wr filled">
      <b-row>
        <b-col cols="12">
          <div class="pm-header-top floatCss d-flex justify-content-between">
            <div class="pm-logo-left d-flex">
              <div class="pm-logo">
                <img
                  :src="logoSrc"
                  style="width: 162px; height: auto;"
                >
              </div>
              <div class="pm-logo-text">
                <h3>NIRVANA PRESTIGE PTE. LTD.<span>(UEN NO: 201602195C)</span></h3>
                <h4>AS THE AUTHORISED agent OF THIAN LENG CHONG TOH TONG</h4>
              </div>
            </div>
            <div class="pm-right">
              <div class="pm-right-cn">
                <div class="pm-right-label">
                  File No:
                </div>
                <div class="pm-right-dt" />
              </div>
              <div class="pm-right-bottom">
                <p>Sales Order No: {{ formData.orderNo || 'N-12345' }}</p>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12">
          <b-row>
            <b-col
              cols="5"
              md="5"
              lg="5"
            >
              <div class="cm-header-info">
                <p>Address: 472 Changi Road Singapore 419890</p>
              </div>
            </b-col>
            <b-col
              cols="7"
              md="7"
              lg="7"
            >
              <div class="cm-header-info-right">
                <div class="cm-header-info">
                  <p>Tel: +65 68909719</p>
                </div>
                <div class="cm-header-info">
                  <p>Website: Thianleng.sg</p>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <div class="pp-section-tittle pp-gap-15">
            <h2>SALES ORDER - NICHE 骨灰灵位认购同意书</h2>
          </div>
        </b-col>
      </b-row>
      <b-row class="payment-plan-section">
        <b-col cols="12">
          <b-row>
            <b-col cols="12">
              <div class="pp-section-tittle">
                <h3>Earliest Interment Date: <strong>Immediate</strong> <span>Need Type: <strong>{{ formData.needType || 'Pre-need' }}</strong></span></h3>
                <p>I hereby agree to purchase the Licence for the niche specified hereunder in the columbarium known as "THIAN LENG CHONG TOH TONG" for the consideration stipulated herein upon the terms and subject to the conditions attached herein and as set forth overleaf.</p>
                <h4>本人同意购买下列位于“天灵总道堂”骨灰殿内的骨灰灵位使用权，售价注明如下，并遵守以下及背页所附的条件。</h4>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="ssfp-form-wrapper">
        <b-col cols="12">
          <b-row>
            <b-col cols="12">
              <div class="pp-section-tittle2">
                <h2>PARTICULARS of purchaser 购买者资料</h2>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-single-row">
            <b-col cols="12">
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-1">
                  Full Name as in NRIC / Passport <br>身份证 / 护照上的全名
                </div>
                <div class="ssfp-text-field-input-1">
                  {{ formData.customerName || '-' }}
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-single-row">
            <b-col
              cols="7"
              md="7"
              lg="7"
            >
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-1">
                  NRIC/ Passport No <br>身份证/ 护照号码
                </div>
                <div class="ssfp-text-field-input-1">
                  {{ formData.customerNric || '-' }}
                </div>
              </div>
            </b-col>
            <b-col
              cols="5"
              md="5"
              lg="5"
            >
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-2">
                  Nationality <br>国籍
                </div>
                <div class="ssfp-text-field-input-2">
                  {{ formData.customerNationality || '-' }}
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-single-row">
            <b-col
              cols="7"
              md="7"
              lg="7"
            >
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-1">
                  Birth Date <br>出生日期
                </div>
                <div class="ssfp-text-field-input-1">
                  {{ formData.customerDob || '-' }}
                </div>
              </div>
            </b-col>
            <b-col
              cols="5"
              md="5"
              lg="5"
            >
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-2">
                  Sex <br>性別
                </div>
                <div class="ssfp-text-field-input-3">
                  <div
                    class="ssfp-check-box"
                    :class="{ active: formData.customerSex === 'Male' }"
                  >
                    Male 男
                  </div>
                  <div
                    class="ssfp-check-box"
                    :class="{ active: formData.customerSex === 'Female' }"
                  >
                    Female 女
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-single-row">
            <b-col cols="12">
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-1">
                  Permanent Address <br>永久地址
                </div>
                <div class="ssfp-text-field-input-1">
                  {{ formData.permanentAddress }}
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-single-row">
            <b-col cols="12">
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-1">
                  Correspondence Address <br>通讯地址
                </div>
                <div class="ssfp-text-field-input-1">
                  {{ formData.correspondenceAddress }}
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-single-row">
            <b-col
              cols="7"
              md="7"
              lg="7"
            >
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-1">
                  E-mail Address <br>电邮
                </div>
                <div class="ssfp-text-field-input-1">
                  {{ formData.customerEmail || '-' }}
                </div>
              </div>
            </b-col>
            <b-col
              cols="5"
              md="5"
              lg="5"
            >
              <div class="ssfp-text-field-row floatCss">
                <div class="ssfp-text-field-single ssfp-field-width-2">
                  Contact No. <br>联络号码
                </div>
                <div class="ssfp-text-field-input-2">
                  {{ formData.customerContact || '-' }}
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-10"
            >
              <div class="pp-section-tittle2">
                <h2>PARTICULARS of intended user 受提名使用者资料</h2>
              </div>
            </b-col>
          </b-row>
          <!-- eslint-disable -->
          <template
            v-for="(item, index) in formData.intendedUsers"
          >
            <b-row
              :key="index"
              class="ssfp-single-row"
            >
              <b-col
                cols="7"
                md="7"
                lg="7"
              >
                <div class="ssfp-text-field-row floatCss">
                  <div class="ssfp-text-field-single ssfp-field-width-1">
                    Name <br>姓名
                  </div>
                  <div class="ssfp-text-field-input-1">
                    {{ item.name || '-' }}
                  </div>
                </div>
              </b-col>
              <b-col
                cols="5"
                md="5"
                lg="5"
              >
                <div class="ssfp-text-field-row floatCss">
                  <div class="ssfp-text-field-single ssfp-field-width-2">
                    NRIC No. <br>身份证号码
                  </div>
                  <div class="ssfp-text-field-input-2">
                    {{ item.nric || '-' }}
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row
              :key="index"
              class="ssfp-single-row"
              :class="{ 'custom-gap-10': index !== formData.intendedUsers.length - 1 }"
            >
              <b-col
                cols="7"
                md="7"
                lg="7"
              >
                <div class="ssfp-text-field-row floatCss">
                  <div class="ssfp-text-field-single ssfp-field-width-1">
                    Birth Date <br>出生日期
                  </div>
                  <div class="ssfp-text-field-input-1">
                    {{ formatDate(item.dob) }}
                  </div>
                </div>
              </b-col>
              <b-col
                cols="5"
                md="5"
                lg="5"
              >
                <div class="ssfp-text-field-row floatCss">
                  <div class="ssfp-text-field-single ssfp-field-width-2">
                    Relationship <br>关系
                  </div>
                  <div class="ssfp-text-field-input-2">
                    {{ item.relation || '-' }}
                  </div>
                </div>
              </b-col>
            </b-row>
          </template>
          <!-- eslint-enable -->
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-10"
            >
              <div class="pp-section-tittle2">
                <h2>PARTICULARS of the niche to which this license relates  骨灰灵位资料</h2>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-pl-single-row">
            <b-col
              cols="6"
              md="6"
              lg="6"
            >
              <div class="ssfp-pl-block floatCss">
                <div class="ssfp-pl-block floatCss">
                  <h3>{{ formData.nicheNo }} • {{ formData.lotType }} Lot 双位</h3>
                </div>
                <div class="ssfp-pl-list floatCss">
                  <div class="ssfp-pl-left-label floatCss">
                    Niche Price 骨灰灵位价格
                  </div>
                  <div class="ssfp-pl-right-amount floatCss">
                    $ {{ numberFormat(formData.lotPrice) }}
                  </div>
                </div>
                <div class="ssfp-pl-list floatCss">
                  <div class="ssfp-pl-left-label floatCss">
                    Sinking Fund & Maintenance Fees 储备金及维修费
                  </div>
                  <div class="ssfp-pl-right-amount floatCss">
                    $ {{ numberFormat(formData.maintenanceFee) }}
                  </div>
                </div>
                <div class="ssfp-pl-list floatCss">
                  <div class="ssfp-pl-left-label floatCss">
                    Others
                  </div>
                  <div class="ssfp-pl-right-amount floatCss border-bottom" />
                </div>
                <div class="ssfp-pl-list floatCss">
                  <div class="ssfp-pl-left-label floatCss">
                    <strong>Total 总额</strong>>
                  </div>
                  <div class="ssfp-pl-right-amount floatCss">
                    $ {{ numberFormat(formData.lotPrice - (-formData.maintenanceFee)) }}
                  </div>
                </div>
              </div>
            </b-col>
            <b-col
              cols="6"
              md="6"
              lg="6"
            >
              <div class="ssfp-pl-block-right floatCss">
                <h3>NOTES</h3>
                <ol>
                  <li>All payments must be made payable to <strong>"NIRVANA PRESTIGE PTE. LTD." ("Authorised Agent")</strong>. Please write File No. and Name of the payee on the reverse side of the cheque. Payment must be made at any authorised sales counter of the Authorised Agent.</li>
                  <Li>Please attach a photocopy of the purchaser’s identity card / passport for our reference.</li>
                </ol>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-10"
            >
              <div class="pp-section-tittle2">
                <h2>PARTICULARS of service advisor  服务顾问资料</h2>
              </div>
            </b-col>
          </b-row>
          <b-row class="ssfp-pl-single-row">
            <b-col
              cols="8"
              md="8"
              lg="8"
            >
              <div class="ssfp-pl-block floatCss">
                <div class="ssfp-pl-list floatCss">
                  <div class="ssfp-pl-left-label floatCss">
                    Agency 区代理
                  </div>
                  <div class="ssfp-pl-right-amount max-width floatCss">
                    {{ formData.agency }}
                  </div>
                </div>
                <div class="ssfp-pl-list floatCss">
                  <div class="ssfp-pl-left-label floatCss">
                    Service Advisor 服务顾问
                  </div>
                  <div class="ssfp-pl-right-amount floatCss">
                    {{ formData.serviceAdvisor }}
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <!-- eslint-disable-next-line vue/html-self-closing -->
    <div class="page-break-after"></div>
    <div class="formWrapper filled">
      <b-row>
        <b-col cols="12">
          <div class="pm-header-top floatCss d-flex justify-content-between">
            <div class="pm-logo-left d-flex">
              <div class="pm-logo">
                <img
                  :src="logoSrc"
                  style="width: 162px; height: auto;"
                >
              </div>
              <div class="pm-logo-text">
                <h3>NIRVANA PRESTIGE PTE. LTD.<span>(UEN NO: 201602195C)</span></h3>
                <h4>AS THE AUTHORISED agent OF THIAN LENG CHONG TOH TONG</h4>
              </div>
            </div>
            <div class="pm-right">
              <div class="pm-right-cn">
                <div class="pm-right-label">
                  File No:
                </div>
                <div class="pm-right-dt" />
              </div>
              <div class="pm-right-bottom">
                <p>Sales Order No: {{ formData.orderNo || 'N-12345' }}</p>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12">
          <b-row>
            <b-col
              cols="5"
              md="5"
              lg="5"
            >
              <div class="cm-header-info">
                <p>Address: 472 Changi Road Singapore 419890</p>
              </div>
            </b-col>
            <b-col
              cols="7"
              md="7"
              lg="7"
            >
              <div class="cm-header-info-right">
                <div class="cm-header-info">
                  <p>Tel: +65 68909719</p>
                </div>
                <div class="cm-header-info">
                  <p>Website: Thianleng.sg</p>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <div class="pp-section-tittle pp-gap-15">
            <h2>SALES ORDER - NICHE 骨灰灵位认购同意书</h2>
          </div>
        </b-col>
      </b-row>
      <b-row class="ssfp-form-wrapper">
        <b-col cols="12">
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-10"
            >
              <div class="pp-section-tittle2">
                <h2>Personal Data Consent 个人资料使用同意书</h2>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-10"
            >
              <div
                class="pp-ssfp-check-info floatCss"
                :class="{ 'active': formData.personalDataConsent == 'true' }"
              >
                I further declare that the Company has made available to me, the Company’s Customer Privacy Policy Statement (“Statement”) as required under the Personal Data Protection Act (Act 26 of 2012), and having read and inspected the same, hereby agree that I consent to the Company processing my personal data, and confirm that I have authority to provide the personal data of any third parties for processing by the Company in accordance with the Notice.
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="pp-section-tittle2">
                <h2>marketing consent 声明</h2>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="pp-section-tittle3 floatCss">
                <p>From time to time, the Group may use personal data disclosed by you in this Form to send you advertising and promotional material. If you do not wish to receive such material, kindly check the box below.</p>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              cols="12"
              class="custom-gap-10"
            >
              <div
                class="pp-ssfp-check-info floatCss"
                :class="{ 'active': formData.marketingDataConsent == 'true' }"
              >
                No, I would not like to receive advertising and promotional material from the Group.
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row class="ssfp-signature">
        <b-col cols="12">
          <div class="pp-signature-area floatCss">
            <p>Purchaser 购买者签名</p>
          </div>
        </b-col>
        <b-col cols="12">
          <b-row>
            <b-col
              cols="6"
              md="6"
              lg="6"
            >
              <div class="pp-signature-block floatCss">
                <img
                  v-if="formData.signOne"
                  :src="formData.signOne"
                  alt="signature"
                >
                <span v-else>Sign here</span>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <div class="pp-signature-area floatCss">
            <h4>Name 姓名: {{ formData.customerName }}</h4>
            <h4 v-if="formData.signOne">
              Date 日期: {{ dateFormat() }}
            </h4>
            <h4 v-else>
              Date 日期: {{ dateFormat() }}
            </h4>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- eslint-disable-next-line vue/html-self-closing -->
    <div class="page-break-after"></div>
    <div class="formWrapper filled">
      <b-row>
        <b-col cols="12">
          <div class="pm-header-top floatCss d-flex justify-content-between">
            <div class="pm-logo-left d-flex">
              <div class="pm-logo">
                <img
                  :src="logoSrc"
                  style="width: 162px; height: auto;"
                >
              </div>
              <div class="pm-logo-text">
                <h3>NIRVANA PRESTIGE PTE. LTD.<span>(UEN NO: 201602195C)</span></h3>
                <h4>AS THE AUTHORISED agent OF THIAN LENG CHONG TOH TONG</h4>
              </div>
            </div>
            <div class="pm-right">
              <div class="pm-right-cn">
                <div class="pm-right-label">
                  File No:
                </div>
                <div class="pm-right-dt" />
              </div>
              <div class="pm-right-bottom">
                <p>Sales Order No: {{ formData.orderNo || 'N-12345' }}</p>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12">
          <b-row>
            <b-col
              cols="5"
              md="5"
              lg="5"
            >
              <div class="cm-header-info">
                <p>Address: 472 Changi Road Singapore 419890</p>
              </div>
            </b-col>
            <b-col
              cols="7"
              md="7"
              lg="7"
            >
              <div class="cm-header-info-right">
                <div class="cm-header-info">
                  <p>Tel: +65 68909719</p>
                </div>
                <div class="cm-header-info">
                  <p>Website: Thianleng.sg</p>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <div class="pp-section-tittle pp-gap-15">
            <h2>SALES ORDER - NICHE 骨灰灵位认购同意书</h2>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="custom-gap-top-20"
        >
          <div class="pp-section-tittle2">
            <h2>TERMS & CONDITIONS</h2>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="custom-gap-top-20"
        >
          <div class="tc-single-wrapper floatCss">
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                1.
              </div>
              <div class="tc-info-rt">
                <p>THIAN LENG CHONG TOH TONG (UEN No. S61SS0096D), holding via its trustees (<strong>"Temple"</strong>) is the registered owner of the columbarium known as <strong>"THIAN LENG CHONG TOH TONG”</strong> (<strong>“Columbarium”</strong>) situated at the piece of land known as Lot 5513N of Mukim 26 comprised in Certificate of Title Volume 595 Folio 195 and bearing postal address at 472 Changi Road, Singapore 419890 (<strong>"Land"</strong>).</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                2.
              </div>
              <div class="tc-info-rt">
                <p>NIRVANA PRESTIGE PTE. LTD. (UEN No. 201602195C) (<strong>"Authorised Agent”</strong>) is the Temple’s authorised agent.</p>
              </div>
            </div>
            <div class="pp-section-tittle2 floatCss">
              <h4>LICENCE</h4>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                3.
              </div>
              <div class="tc-info-rt">
                <p>Subject to the terms and conditions hereof, including Clause 17 hereof, the licence granted herein shall be perpetual.</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                4.
              </div>
              <div class="tc-info-rt">
                <p>The licence hereby granted does not confer any proprietary interest to the Purchaser or his next-of-kin.</p>
              </div>
            </div>
            <div class="pp-section-tittle2 floatCss">
              <h4>PAYMENT</h4>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                5.
              </div>
              <div class="tc-info-rt">
                <p>Subject to the Purchaser's (i) full payment of the purchase price as set out in this Sales Order; and (ii) registration with the Temple (or its designated representative) as the registered participant or devotee of the Thian Leng Chong Toh Tong Temple, the Purchaser shall be entitled to a licence to use the niche identified and described herein solely for the purpose of the deposition of one cinerary urn unless specified otherwise.</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                6.
              </div>
              <div class="tc-info-rt">
                <div class="floatCss">
                  <p>The balance of the purchase price shall be immediately due and payable upon the exercise of the licence and interment of the cinerary urn. Nothing in this Sales Order precludes the Temple/Authorised Agent's right to recover any balance purchase price from the Purchaser where the licence has been exercised and interment of the cinerary urn has been duly completed.</p>
                  <ol>
                    <li>Service Charge of $500.00 (plus prevailing GST rate, if applicable) for 2nd utilisation (this charge may be subjected to changes).</li>
                    <li>Any additional products and services will be subject to additional fees where the amount may be subjected to changes.</li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                7.
              </div>
              <div class="tc-info-rt">
                <p>All payments in respect of the licence granted herein, including the purchase price, sinking fund and maintenance fee, whether made by cheque, bank draft, electronic transfer or any other means shall be made under and in the name of “NIRVANA PRESTIGE PTE. LTD.”, being the authorised agent of the Temple, who is duly authorised to receive all such payments made hereto. Confirmation of purchase is subject to the clearance of the cheque, bank draft or successful completion of such payment. The File No. and the name of the payee must be indicated clearly on the reverse side of any cheque or bank draft, or in the payment reference for electronic transfers.</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                8.
              </div>
              <div class="tc-info-rt">
                <p>Payment in NETS and credit card must be made directly at the sales counter of the Authorised Agent. Only authorised staffs of the Authorised Agent at the sales counter are allowed to collect payment on behalf of the Authorised Agent from the Purchaser. Service advisors have no authority to collect cash payments and/or issue personal receipts on behalf of the Authorised Agent and/or the Temple.</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                9.
              </div>
              <div class="tc-info-rt">
                <p>If deemed necessary by the Temple, additional sinking fund and maintenance fees may be levied at any time after the lapse of thirty (30) years from the date of interment of the cinerary urn, in order to ensure the continuous upkeep and maintenance of the Columbarium in good and tenantable repair and condition.</p>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- eslint-disable-next-line vue/html-self-closing -->
    <div class="page-break-after"></div>
    <div class="formWrapper filled">
      <b-row>
        <b-col cols="12">
          <div class="pm-header-top floatCss d-flex justify-content-between">
            <div class="pm-logo-left d-flex">
              <div class="pm-logo">
                <img
                  :src="logoSrc"
                  style="width: 162px; height: auto;"
                >
              </div>
              <div class="pm-logo-text">
                <h3>NIRVANA PRESTIGE PTE. LTD.<span>(UEN NO: 201602195C)</span></h3>
                <h4>AS THE AUTHORISED agent OF THIAN LENG CHONG TOH TONG</h4>
              </div>
            </div>
            <div class="pm-right">
              <div class="pm-right-cn">
                <div class="pm-right-label">
                  File No:
                </div>
                <div class="pm-right-dt" />
              </div>
              <div class="pm-right-bottom">
                <p>Sales Order No: {{ formData.orderNo || 'N-12345' }}</p>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12">
          <b-row>
            <b-col
              cols="5"
              md="5"
              lg="5"
            >
              <div class="cm-header-info">
                <p>Address: 472 Changi Road Singapore 419890</p>
              </div>
            </b-col>
            <b-col
              cols="7"
              md="7"
              lg="7"
            >
              <div class="cm-header-info-right">
                <div class="cm-header-info">
                  <p>Tel: +65 68909719</p>
                </div>
                <div class="cm-header-info">
                  <p>Website: Thianleng.sg</p>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <div class="pp-section-tittle pp-gap-15">
            <h2>SALES ORDER - NICHE 骨灰灵位认购同意书</h2>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="custom-gap-top-20"
        >
          <div class="tc-single-wrapper floatCss">
            <div class="pp-section-tittle2 floatCss">
              <h4>TRANSFER</h4>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                10.
              </div>
              <div class="tc-info-rt">
                <p>The Purchaser is at liberty at any time to transfer his rights to the niche by furnishing the documentary evidence proving the licence as granted herein and such other documents as reasonably required by the Company and paying a transfer fee of $300.00 (plus prevailing GST rate, if applicable) prior to the transfer. No transfer in any manner whatsoever will be permitted after the licence granted herein has been exercised by the interment of the cinerary urn.</p>
              </div>
            </div>
            <div class="pp-section-tittle2 floatCss">
              <h4>GENERAL</h4>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                11.
              </div>
              <div class="tc-info-rt">
                <p>Only a Sales Order accepted by the Authorised Agent is valid and binding on the Temple. Upon acceptance by the Authorised Agent, a notification confirming the granting of the licence herein in such form as may be determined by the Authorised Agent ("Notification") will be issued within 60 days upon full payment of the purchase price.</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                12.
              </div>
              <div class="tc-info-rt">
                <p>If any transaction is not confirmed within 10 days of the booking fee being paid, the said transaction may be terminated at the sole and absolute discretion of the Authorised Agent, and upon such termination, the booking fee will be refunded, less 10% for processing fees. For the purpose of this Sales Order, a transaction is deemed confirmed if at least 10% of the purchase price has been received by the Authorised Agent within the aforesaid 10 days' period.</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                13.
              </div>
              <div class="tc-info-rt">
                <p>Once a transaction is confirmed, there shall be no refund of the purchase price.</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                14.
              </div>
              <div class="tc-info-rt">
                <p>The Temple may, from time to time, make rules and regulations governing the use and maintenance of the Columbarium and may at any time or times, amend, alter, change or modify the terms and conditions of this Sales Order related thereto. All terms and conditions contained hereof together with any amendments, alterations, changes or modifications thereof, and all rules and regulations made pursuant thereto, shall apply to and be binding upon the Purchaser.</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                15.
              </div>
              <div class="tc-info-rt">
                <p>If deemed necessary for the proper operation, maintenance, repair or safety of the Columbarium or for any other reasonable cause, including but not limited to reconstruction, renovation or refurbishment, the Temple may in its sole discretion, move, reposition or relocate any niche or pedestal.</p>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                16.
              </div>
              <div class="tc-info-rt">
                <p>All notices are required to be given in writing. Any notice to the Purchaser shall be sufficiently served if sent by prepaid post addressed to the Purchaser at the Purchaser’s address herein stated or to the Purchaser's last known address. It is the Purchaser's duty to inform the Temple and the Authorised Agent of any change of address.</p>
              </div>
            </div>
            <div class="pp-section-tittle2 floatCss">
              <h4>TERMINATION</h4>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                17.
              </div>
              <div class="tc-info-rt">
                <div class="floatCss">
                  <p>The licence may be terminated automatically whereupon the Temple shall have the liberty to dispose of or deal with the niche in such manner as the Temple shall in its sole discretion think fit without having to account to the Purchaser in any manner whatsoever and without having to make a refund to the Purchaser of any monies already paid, following the occurrence of any of the following events:-</p>
                  <ol>
                    <li>When the Purchaser gives the Temple notice of termination of the licence or notice of his intention to open the niche and remove the cinerary urn deposited therein; and/or</li>
                    <li>When the Purchaser himself removes the cinerary urn from the niche for any reason whatsoever; and/or</li>
                    <li>When the purchase price for the niche herein is paid under an instalment scheme, if the Purchaser defaults in the payment of any instalment for more than 30 days; and/or</li>
                    <li>When the Purchaser is in breach of Clause 9 hereof or any provisions of the House Rules (as defined hereinbelow) issued by the Temple from time to time.</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <!-- eslint-disable-next-line vue/html-self-closing -->
    <div class="page-break-after"></div>
    <div class="formWrapper filled">
      <b-row>
        <b-col cols="12">
          <div class="pm-header-top floatCss d-flex justify-content-between">
            <div class="pm-logo-left d-flex">
              <div class="pm-logo">
                <img
                  :src="logoSrc"
                  style="width: 162px; height: auto;"
                >
              </div>
              <div class="pm-logo-text">
                <h3>NIRVANA PRESTIGE PTE. LTD.<span>(UEN NO: 201602195C)</span></h3>
                <h4>AS THE AUTHORISED agent OF THIAN LENG CHONG TOH TONG</h4>
              </div>
            </div>
            <div class="pm-right">
              <div class="pm-right-cn">
                <div class="pm-right-label">
                  File No:
                </div>
                <div class="pm-right-dt" />
              </div>
              <div class="pm-right-bottom">
                <p>Sales Order No: {{ formData.orderNo || 'N-12345' }}</p>
              </div>
            </div>
          </div>
        </b-col>
        <b-col cols="12">
          <b-row>
            <b-col
              cols="5"
              md="5"
              lg="5"
            >
              <div class="cm-header-info">
                <p>Address: 472 Changi Road Singapore 419890</p>
              </div>
            </b-col>
            <b-col
              cols="7"
              md="7"
              lg="7"
            >
              <div class="cm-header-info-right">
                <div class="cm-header-info">
                  <p>Tel: +65 68909719</p>
                </div>
                <div class="cm-header-info">
                  <p>Website: Thianleng.sg</p>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <div class="pp-section-tittle pp-gap-15">
            <h2>SALES ORDER - NICHE 骨灰灵位认购同意书</h2>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="12"
          class="custom-gap-top-20"
        >
          <div class="tc-single-wrapper floatCss">
            <div class="pp-section-tittle2 floatCss">
              <h4>USAGE</h4>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                18.
              </div>
              <div class="tc-info-rt">
                <div class="floatCss">
                  <p>The Purchaser SHALL:--</p>
                  <ol>
                    <li>With his invitees, observe proper decorum and the code of conduct and house rules applicable to the Temple’s premises / Columbarium (collectively, “House Rules”), which is reviewable from time to time, at all times on the premises / Columbarium;</li>
                    <li>Inform the Temple at least 24-hours before any installation; and</li>
                    <li>Maintain its registration with the Temple (or its designated representative) as the registered participant or devotee of the Thian Leng Chong Toh Tong Temple for the purpose of receiving privileged information, notification, updates and invitation relating to religious and prayer events.</li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                19.
              </div>
              <div class="tc-info-rt">
                <div class="floatCss">
                  <p>The purchase of the niche is purely for the Purchaser's or nominated intended user’s use and not for investment or for speculative purposes.</p>
                  <ol>
                    <li>The Purchaser intends that the niche shall be used by the intended user named in this Sales Order. Where no person has been nominated, the Purchaser shall be deemed to be the intended user of the niche.</li>
                    <li>Until the interment of a cinerary urn into the niche, the Purchaser may by notice in writing to the Temple nominate such person from time to time to be the intended user of the niche.</li>
                    <li>If the niche is not ready for use at the date of the full payment of the purchase for the licence granted herein, the Notification shall expressly state so and the estimated date of completion of the niche shall be set out thereto. The Purchaser shall not be entitled to annul the purchase herein under any circumstances.</li>
                  </ol>
                </div>
              </div>
            </div>
            <div class="pp-section-tittle2 floatCss">
              <h4>LIMITING LIABILITY</h4>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                20.
              </div>
              <div class="tc-info-rt">
                <div class="floatCss">
                  <p>The Temple and/or Authorised Agent shall not be liable to the Purchaser in any manner whatsoever resulting from or arising out of any loss or damage to any material chattels or things deposited in the niche.</p>
                </div>
              </div>
            </div>
            <div class="tc-single-block-pp floatCss">
              <div class="tc-single-number">
                21.
              </div>
              <div class="tc-info-rt">
                <p>Neither the Temple nor the Authorised Agent shall be liable for any claims, demands, actions, losses or damages of any kind whatsoever resulting or arising from this Sales Order or which the Purchaser may suffer or incur in connection with loss of life, personal injury and/or damage to property arising from or out of any occurrences in, upon or at the Temple and/or Authorised Agent’s premises or any part thereof for an amount in excess of 50% of the net purchase price of the product in question.</p>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row class="ssfp-signature">
        <b-col cols="12">
          <div class="pp-signature-area floatCss">
            <p>Purchaser 购买者签名</p>
          </div>
        </b-col>
        <b-col cols="12">
          <b-row>
            <b-col
              cols="6"
              md="6"
              lg="6"
            >
              <div class="pp-signature-block floatCss">
                <img
                  v-if="formData.signTwo"
                  :src="formData.signTwo"
                  alt="signature"
                >
                <span v-else>Sign here</span>
              </div>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <div class="pp-signature-area floatCss">
            <h4>Name 姓名: {{ formData.customerName }}</h4>
            <h4 v-if="formData.signTwo">
              Date 日期: {{ dateFormat() }}
            </h4>
            <h4 v-else>
              Date 日期: {{ dateFormat() }}
            </h4>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'

import moment from 'moment'

export default {
  components: {
    BRow,
    BCol,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      logoSrc: require('@/assets/images/logo/niche-pdf-logo.png'),
      formData: JSON.parse(localStorage.getItem('installmentFormData')) || {},
    }
  },

  methods: {
    formatDate(date) {
      if (!date) return '-'
      const timezone = process.env.VUE_APP_TIME_ZONE
      return moment(date).utcOffset(timezone).format('DD/MM/YYYY')
    },
  },
}
</script>

<style>
@media print {
    .page-break-after {
        display: block;              /* ensure block context */
        page-break-before: always;   /* legacy */
        break-before: page;
    }
    .formWrapper,
    .niche-wr,
    .ssfp-form-wrapper,
    .ssfp-signature {
      page-break-inside: avoid;   /* legacy */
      break-inside: avoid;        /* modern */
    }
}
</style>
